/**
 * DefenseBuilderLink
 *
 * The Simulator's entry point to the Defense Play Maker, which is a premium feature.
 *
 * It used to be hidden from anyone not signed in, which made the feature invisible to exactly the
 * people who might pay for it — and inconsistent with a free account, who could open the builder
 * and only discover the limit when saving failed. Now everyone sees it: premium users get a
 * working link, everyone else gets the same control, locked, with a route to upgrade.
 *
 * Locked means `disabled` on a real button, not a styled anchor. There is no href to middle-click
 * and no handler to fire, so the lock is the absence of a way through rather than a look.
 */

import { Link } from 'react-router-dom';
import { usePremiumStatus } from '../hooks';

const LABEL = '🛠️ Defense Play Maker';

function DefenseBuilderLink() {
  const { isPremium, isLoading } = usePremiumStatus();

  // Render nothing until the tier is known. Showing the working link first and locking it a moment
  // later would flash a usable control at a free user.
  if (isLoading) return null;

  if (isPremium) {
    return (
      <Link to="/defense-builder" className="defense-builder-link">
        {LABEL}
      </Link>
    );
  }

  return (
    <>
      <button className="defense-builder-link defense-builder-link-locked" disabled type="button" title="Premium feature">
        🔒 {LABEL}
      </button>
      <a className="defense-builder-upgrade-link" href="/pricing">
        Build custom defenses with Premium
      </a>
    </>
  );
}

export default DefenseBuilderLink;
